import axios from "axios";
import Config from "../Config";
import RequestUtil from "@/utils/RequestUtil.js";

export default {
  // 통합회원 탈퇴 철회 API
  cancelWithdrawal(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/cancel/withdraw";
    return axios.post(url, param, config);
  },
  // 통합회원 탈퇴 철회 정보조회 API
  getCancelWithdrawal(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/get/cancel/withdraw";
    return axios.post(url, param, config);
  },
  cancelWithdrawalServiceTerms(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/cancel/withdraw/service/terms";
    return axios.post(url, param, config);
  },
  resetPassword(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/reset/password";
    return axios.post(url, param, config);
  },
  // 이투스 중복 아이디 계정 처리 마지막 단게의 암호 변경 요청 API
  resetEtoosPassword(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/etoos/reset/password`;
    return axios.post(url, param, config);
  },
  changePassword(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/change/password";
    return axios.post(url, param, config);
  },
  getWakeupDormant(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/get/wakeup/dormant";
    return axios.post(url, param, config);
  },
  wakeupDormant(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/wakeup/dormant";
    return axios.post(url, param, config);
  },
  // 회원 정보 조회 API
  getUserInfo(config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user";
    return axios.get(url, config);
  },
  // 세션키 생성 API
  getSessionKey(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/request/sessionkey";
    return axios.post(url, param, config);
  },
  // 통합회원 정보 변경 API
  updateIntegratedUserInfo(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/change/name";
    return axios.post(url, param, config);
  },
  // 서비스별 회원 정보 호출 API
  getServiceList(config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/service/terms";
    return axios.get(url, config);
  },
  // 비밀번호 확인
  checkPassword(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/check/password";
    return axios.post(url, param, config);
  },
  changePhoneId(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/change/phone/id";
    return axios.post(url, param, config);
  },
  addEmailId(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/add/email/id";
    return axios.post(url, param, config);
  },
  addEmailPassword(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/add/email/id/password";
    return axios.post(url, param, config);
  },
  addPhonePassword(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/add/phone/id/password";
    return axios.post(url, param, config);
  },
  changeUsableId(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/usable/id";
    return axios.post(url, param, config);
  },
  changeEmail(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/change/email";
    return axios.post(url, param, config);
  },
  changePhone(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/user/change/phone";
    return axios.post(url, param, config);
  },
  // 점유 인증 요청
  requestPossession(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/request/possession";
    return axios.post(url, param, config);
  },
  // 점유 인증 확인 API
  checkPossession(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/verify/possession";
    return axios.post(url, param, config);
  },
  // 이투스 미인증 아이디 조회
  getUserPossessionInfo(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/get/possession/id`;
    return axios.post(url, param, config);
  },
  // 서비스별 회원 정보 호출 API
  getServiceUserInfo(serviceId, config) {
    const url = Config.API_DOMAIN + `/ext/members/v1/user/${serviceId}/profile`;
    return axios.get(url, config);
  },
  // 서비스별 회원 정보 변경 API
  updateServiceUserInfo(serviceId, param, config) {
    const url = Config.API_DOMAIN + `/ext/members/v1/user/change/${serviceId}/profile`;
    return axios.post(url, param, config);
  },
  /// 통합 회원 탈퇴
  withdraw(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/withdraw`;
    return axios.post(url, param, config);
  },
  // 통합 회원 광고 수신 동의 조회
  getIntegreatedMarketingAgree(config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/reception`;
    return axios.get(url, config);
  },
  // 통합 회원 광고 수신 동의 변경
  updateIntegreatedMarketingAgree(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/change/reception`;
    return axios.post(url, param, config);
  },
  // 서비스 회원 광고 수신 동의 변경
  updateServicedMarketingAgree(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/change/service/reception`;
    return axios.post(url, param, config);
  },
  // 약관 목록 API
  getTermList(param, config) {
    const url = Config.API_DOMAIN + "/ext/members/v1/common/need/terms" + RequestUtil.getPasingParam(param);
    return axios.get(url, config);
  },
  // 휴대폰 ID 변경 가능 여부 확인
  getCheckChangePhoneId(config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/check/phone/id`;
    return axios.get(url, config);
  },
  // 이름 변경 가능 여부 확인
  getCheckChangeName(config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/check/change/name`;
    return axios.get(url, config);
  },
  // 패스워드 변경 확인 날짜 업데이트 (90일 이후) API
  updatePasswordDate(config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/change/password/date`;
    return axios.get(url, config);
  },
  //회원상태 초기화
  async resetMemberState(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/reset/member/state`;
    return axios.post(url, param, config);
  },
  requestJoiningEnable(serviceId, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/service/${serviceId}/check/registration`;
    return axios.get(url, config);
  },
  requestFindAccountInfo(param, config) {
    const url = `${Config.API_DOMAIN}/etoos/members/v2/user/find/account`;
    return axios.post(url, param, config);
  },
  requestResetUserPassword(param, config) {
    const url = `${Config.API_DOMAIN}/etoos/members/v1/user/reset/account/password`;
    return axios.post(url, param, config);
  },
  serviceWithdraw(param, config) {
    const url = `${Config.API_DOMAIN}/ext/members/v1/user/withdraw/service`;
    return axios.post(url, param, config);
  }
};
